import React from 'react';

import { Image, StyleSheet } from 'react-native';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import {
  EmptyScreenWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const friesImage = require('./fries.png');

const OffersEmptyScreen: React.FC = () => {
  // Texts and link path change depending on store is select or not
  const headerText = 'offersNoOffersAvailable';
  const subHeaderText = 'offersYouCanStillEnjoyYourFavorites';
  const linkText = 'orderNow';
  const linkPath = routes.menu;

  return (
    <EmptyScreenWrapper>
      <ImageWrapper>
        <Image style={styles.image} source={friesImage} />
      </ImageWrapper>
      <HeaderText>{t(headerText)}</HeaderText>
      <SubText>{t(subHeaderText)}</SubText>
      <StyledActionButtonLink to={linkPath}>{t(linkText)}</StyledActionButtonLink>
    </EmptyScreenWrapper>
  );
};

const styles = StyleSheet.create({
  image: {
    width: 300,
    height: 300,
  },
});

export default OffersEmptyScreen;
